import React from 'react';
// Redux
import { useDispatch } from 'react-redux';
import { CommercialActionFilters } from '../../../redux/types/filtersTypes';
import { setFilters, resetFilters } from '../../../redux/actions/FiltersActions';
// App
import DashboardComponent from '../../../components/DashboardComponent';
import CommercialActionsListComponent from '../../../components/CommercialActions/CommercialActionsListComponent';
// Other
import { Switch, Route, Redirect, RouteComponentProps } from 'react-router-dom';

export default function CommercialActionsRouting(props: RouteComponentProps) {
  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(setFilters(new CommercialActionFilters()));
    return () => {
      dispatch(resetFilters());
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <DashboardComponent
      title={<h2>Acciones Comerciales</h2>}
      children={<Switch>
        <Route exact path={props.match.path + '/list'} component={CommercialActionsListComponent} />
        <Redirect to={props.match.path + '/list'} />
      </Switch>}
    />
  );
}
